import React from 'react';

import { ShopContext, Store } from './ShopContext';

export const ShopProvider: React.FC<{ children: React.ReactNode; store: Store }> = ({
  children,
  store,
}) => {
  return (
    <ShopContext.Provider value={{ store, isBaby: store === 'baby' }}>
      {children}
    </ShopContext.Provider>
  );
};
